import $ from "jquery";

$(function () {
	const selectors = {
		editAccountForm: ".js-edit-account",
		submitButton: ".js-submit-edit-account",
		submitResetPassword: ".js-submit-reset-password",
		resetPasswordForm: "#resetPasswordForm",
		resetPasswordSuccess: ".js-reset-password-success",
		resetPasswordError: ".js-reset-password-error",
		editAccountStatus: ".js-account-edit-status",
		firstName: ".js-customer-name",
		lastName: ".js-customer-lastName",
		title: ".js-customer-title",
		gender: "input[name='customer[tags][gender]']:checked",
		order_accordion__info: "[data-accordion-order-info]",
		order_accordion_btn: "[data-accordion-order-button]"
	};
	// Accordeon changes
	$(selectors.order_accordion_btn).on("click", (event) => {
		if ($(selectors.order_accordion__info).hasClass("active")) {
			$(selectors.order_accordion__info).removeClass("active");
			$(event.target).text(window.accountOrderButtonTitle.show);
		} else {
			$(selectors.order_accordion__info).addClass("active");
			$(event.target).text(window.accountOrderButtonTitle.hide);
		}
	});
	if (!$(selectors.editAccountForm).length) {
		return;
	}

	let resetPasswordForm = $(selectors.resetPasswordForm);
	let submitResetPassword = $(selectors.submitResetPassword);
	$(selectors.submitButton).on("click", function (e) {
		e.preventDefault();

		let form = $(selectors.editAccountForm);
		let first_name = $(selectors.firstName).val();
		let last_name = $(selectors.lastName).val();
		let title = $(selectors.title).val();
		let gender = $(selectors.gender).val();

		if (form[0].checkValidity()) {
			$(selectors.submitButton).prop("disabled", true);

			window.CF.customerReady(function () {
				let customerObject;
				customerObject = {
					first_name,
					last_name,
					title,
					gender
				};

				window.CF.customer
					.update(customerObject)
					.then(function () {
						$(selectors.submitButton).prop("disabled", false);
						$(selectors.editAccountStatus).removeClass("hide");
						setTimeout(function () {
							$(selectors.editAccountStatus).addClass("hide");
						}, 3000);
					})
					.catch(function (err) {
						$(
							selectors.editAccountStatus +
								" .customer-page__form-message"
						).innerHTML(err);
						$(selectors.editAccountStatus).removeClass("hide");
						setTimeout(function () {
							$(selectors.editAccountStatus).addClass("hide");
						}, 3000);
					});
			});
		} else {
			// this function return native HTML form validation
			form[0].reportValidity();
		}
	});

	if (selectors.submitResetPassword) {
		$(submitResetPassword).on("click", (event) => {
			event.preventDefault();
			submitForm(event);
		});
	}

	function submitForm(event) {
		event.preventDefault();
		const resetPasswordSuccess = $(selectors.resetPasswordSuccess);
		const resetPasswordError = $(selectors.resetPasswordError);

		$.ajax({
			url: "/account/recover",
			type: "post",
			data: $(resetPasswordForm).serialize(),
			success: function () {
				$(resetPasswordSuccess).css("display", "flex");
				$(resetPasswordError).css("display", "none");
				setTimeout(function () {
					$(resetPasswordSuccess).css("display", "none");
				}, 3000);
			},
			error: function () {
				$(resetPasswordSuccess).css("display", "none");
				$(resetPasswordError).css("display", "flex");
				setTimeout(function () {
					$(resetPasswordError).css("display", "none");
				}, 3000);
			}
		});
	}
});
